import BorderedFilterItemCard from "app/pages/sales-intelligence/common-components/filters-panel/components/FilterItemCard/BorderedFilterItemCard";
import { FilterPanelBaseFilter } from "app/pages/sales-intelligence/modules/advanced-search-filtering/models/BaseFilter";
import type { SearchFilterInstance } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/searchFilterInstance";

import AppsPlatformFilter from "../../components/filters/AppsPlatformFilter/AppsPlatformFilter";
import { type AppOperatingSystem, appOperatingSystemMap } from "../../types/commonFiltersDto";
import { appsFilterCategoryMap } from "../../types/filterCategory";
import appsSearchFiltersI18nKeys from "../../utils/i18n";

const createPlatformFilter = (): SearchFilterInstance => ({
    key: "market",
    trackingName: "App Market",
    apiCategory: "appsFilters",
    category: appsFilterCategoryMap.apps,
    visibility: "always-visible",
    filterCardLayout: "full-width",
    title: { key: appsSearchFiltersI18nKeys.filterTitle("market") },
    tooltipText: { key: appsSearchFiltersI18nKeys.filterTooltip("market") },
    filter: new FilterPanelBaseFilter<AppOperatingSystem, readonly AppOperatingSystem[]>({
        options: [appOperatingSystemMap.android, appOperatingSystemMap.ios],
        initialDtoValue: appOperatingSystemMap.android,
    }),
    filterResultView: AppsPlatformFilter,
    filterCardView: BorderedFilterItemCard,
});

export default createPlatformFilter;
